module.exports = __webpack_public_path__ + "img/sign-25.5893d652.jpg";